import template from "./create-organization-page.html";

const CreateOrganizationPageComponent = {
  bindings: {
    user: "<",
  },
  template: template,
  controller: class CreateOrganizationPageController {
    /* @ngInject */
    constructor($state, $rootScope, Notification, $filter) {
      this.$state = $state;
      this.$rootScope = $rootScope;
      this.NotificationService = Notification;
      this.$filter = $filter;
    }

    $onInit() {
      if (this.user.isOwner()) {
        return this.$state.go("app.dashboard", {
          organization: this.user.defaultOrganization.slug,
        });
      }
    }

    onOrganizationSave(organization) {
      this.$state.go("app.dashboard", { organization: organization.slug });
    }
  },
};

export default CreateOrganizationPageComponent;
